import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  Legend,
} from "recharts";
import SalesByLocations from "./Test1.tsx";
import BreadCrumb from "../common/BreadCrumb.tsx";

const Dashboard = () => {
  // Sample data for the revenue chart
  const revenueData = [
    { name: "Jan", Orders: 35, Earnings: 88, Refunds: 10 },
    { name: "Feb", Orders: 60, Earnings: 98, Refunds: 15 },
    { name: "Mar", Orders: 48, Earnings: 68, Refunds: 8 },
    { name: "Apr", Orders: 70, Earnings: 110, Refunds: 18 },
    { name: "May", Orders: 55, Earnings: 78, Refunds: 22 },
    { name: "Jun", Orders: 62, Earnings: 82, Refunds: 15 },
    { name: "Jul", Orders: 42, Earnings: 52, Refunds: 5 },
    { name: "Aug", Orders: 45, Earnings: 28, Refunds: 9 },
    { name: "Sep", Orders: 72, Earnings: 90, Refunds: 10 },
    { name: "Oct", Orders: 20, Earnings: 50, Refunds: 50 },
    { name: "Nov", Orders: 52, Earnings: 10, Refunds: 90 },
    { name: "Dec", Orders: 72, Earnings: 40, Refunds: 10 },
  ];

  // Sample data for locations
  const locationData = [
    { country: "Canada", percentage: 75 },
    { country: "Greenland", percentage: 47 },
    { country: "Russia", percentage: 82 },
    { country: "Palestine", percentage: 36 },
  ];

  return (
    <>
    <BreadCrumb moduleName={"Dashboard"}/>
    <div className="w-full p-2">
      {/* Remove max-width constraint for ultra-wide screens */}
      <div className="w-full mx-auto  ">
        {/* Main Stats Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-6">
          {/* Total Earnings Card */}
          <div className="bg-slate-50 rounded-lg shadow p-4 relative">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-gray-500 text-sm font-medium">TEMPLATES</h3>
            </div>
            <div className="text-2xl font-bold mb-2">21</div>
            <div className="absolute bottom-4 right-4 bg-green-100 rounded-full p-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-green-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>

          {/* Orders Card */}
          <div className="bg-slate-50 rounded-lg shadow p-4 relative">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-gray-500 text-sm font-medium">DATASETS</h3>
              <div className="text-red-500 text-sm"></div>
            </div>
            <div className="text-2xl font-bold mb-2">6,894</div>
            <div className="absolute bottom-4 right-4 bg-blue-100 rounded-full p-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                />
              </svg>
            </div>
          </div>

          {/* Customers Card */}
          <div className="bg-slate-50 rounded-lg shadow p-4 relative">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-gray-500 text-sm font-medium">
                TRAINED MODAL
              </h3>
              <div className="text-green-500 text-sm"></div>
            </div>
            <div className="text-2xl font-bold mb-2">183</div>
            <div className="absolute bottom-4 right-4 bg-yellow-100 rounded-full p-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-yellow-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
            </div>
          </div>

          {/* Balance Card */}
          <div className="bg-slate-50 rounded-lg shadow p-4 relative">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-gray-500 text-sm font-medium">
                ERROR DATASET
              </h3>
              <div className="text-gray-500 text-sm"></div>
            </div>
            <div className="text-2xl font-bold mb-2">2</div>
            <div className="absolute bottom-4 right-4 bg-indigo-100 rounded-full p-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-indigo-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Charts Section */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6">
          <div className="bg-white rounded-lg shadow p-4 lg:p-6 lg:col-span-2">
            {/* Revenue Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6 text-center">
              <div className="border-r border-gray-200">
                <div className="text-xl font-bold">7,585</div>
                <div className="text-gray-500 text-sm">Orders</div>
              </div>
              <div className="border-r border-gray-200">
                <div className="text-xl font-bold">$22.89k</div>
                <div className="text-gray-500 text-sm">Earnings</div>
              </div>
              <div className="border-r border-gray-200">
                <div className="text-xl font-bold">367</div>
                <div className="text-gray-500 text-sm">Refunds</div>
              </div>
              <div>
                <div className="text-xl font-bold text-green-500">18.92%</div>
                <div className="text-gray-500 text-sm">Conversation Ratio</div>
              </div>
            </div>

            <div className="h-96 min-h-96">
              <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={revenueData}>
                  <defs>
                    <linearGradient
                      id="colorOrders"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.1} />
                      <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} />
                    </linearGradient>
                    <linearGradient
                      id="colorEarnings"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop offset="5%" stopColor="#10b981" stopOpacity={0.1} />
                      <stop offset="95%" stopColor="#10b981" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Area
                    type="monotone"
                    dataKey="Earnings"
                    stroke="#10b981"
                    strokeWidth={2}
                    fill="url(#colorEarnings)"
                    activeDot={{ r: 8 }}
                  />
                  <Area
                    type="monotone"
                    dataKey="Orders"
                    stroke="#3b82f6"
                    strokeWidth={2}
                    fill="url(#colorOrders)"
                  />
                  <Area
                    type="monotone"
                    dataKey="Refunds"
                    stroke="#ef4444"
                    strokeWidth={2}
                    strokeDasharray="5 5"
                    fill="none"
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>

            <div className="flex justify-center mt-4 space-x-8">
              <div className="flex items-center">
                <div className="w-3 h-3 rounded-full bg-blue-500 mr-2"></div>
                <span className="text-sm text-gray-600">Orders</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 rounded-full bg-green-500 mr-2"></div>
                <span className="text-sm text-gray-600">Earnings</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 rounded-full bg-red-500 mr-2"></div>
                <span className="text-sm text-gray-600">Refunds</span>
              </div>
            </div>
          </div>
          <div>
            <SalesByLocations />
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Dashboard;
